export function reverseMap<K, T>(map: Map<K, T>): Map<T, K>
{
    return new Map<T, K>(
        Array.from(map.entries())
            .map(
                ([ k, t ]) => [ t, k ]));
}
